import React from "react";
import van1 from "images/van1.png";
import van2 from "images/van2.png";
import van3 from "images/van3.png";
import van4 from "images/van4.png";
import van from "images/van.png";

const SprinterVansGallery = () => {
  return (
    <section >
      <img
        src={van}
        alt="Sprinter Van Interior"
        className=" object-cover "
      />
    </section>
  );
};

export default SprinterVansGallery;
